
import { useUnifiedDashboardData } from './useUnifiedDashboardData';
import type { DashboardStats, UniqueFilterValues } from './useUnifiedDashboardData';

export type { DashboardStats, UniqueFilterValues };

export const useDashboardData = () => {
  return useUnifiedDashboardData('venda');
};
